// Quick-pick review suggestions grouped by star rating (per product spec)
export const REVIEW_SUGGESTIONS = {
  5: [
    "Excellent service",
    "Amazing experience",
    "Highly recommend",
    "Loved it",
  ],
  4: [
    "Good experience",
    "Nice service",
    "Satisfied",
    "Would recommend",
  ],
  3: [
    "It was okay",
    "Decent service",
    "Nothing special",
    "Average overall",
  ],
  2: [
    "Could be better",
    "Not happy with service",
    "Needs improvement",
    "Average experience",
  ],
  1: [
    "Very bad experience",
    "Poor service",
    "Not satisfied",
    "Would not recommend",
  ],
};
